import { getAuthHeadersWithTokenOnly } from '@discover-frontend/auth';

import { API } from 'src/constants/config';
import { fetchJson } from 'src/utils/fetchJson';

import { HOME_ENDPOINTS } from './constants';

export type ProductLicenses = {
  available: number;
  total: number;
};

export type HomeProduct = {
  id: number;
  name: string;
  slug: string;
  description?: string;
  licenses?: ProductLicenses;
  enabled?: boolean;
};

/**
 * Fetches the complete product catalog. Redux `userProducts` stays
 * entitlement-only because the account settings screens read it to count
 * licenses and gate assignment.
 */
export const fetchAllUserProducts = (
  signal?: AbortSignal
): Promise<HomeProduct[]> =>
  fetchJson<HomeProduct[]>(
    `${API.BASE_URL}${HOME_ENDPOINTS.ALL_USER_PRODUCTS}`,
    {
      method: 'GET',
      headers: getAuthHeadersWithTokenOnly(),
      signal,
    }
  );
